<template>
  <div class="container">
    <div style="margin-bottom: 12px">
      <el-button
        class="mwow-button-filled primary"
        @click="handleExport"
        v-debounce="1000"
        >导出</el-button
      >
    </div>
    <common-search-form-wrapper :reset="resetSearch">
      <el-form size="mini" :model="searchInfo" label-width="90px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="学员阶段:" prop="stage">
              <el-radio-group
                v-model="searchInfo.current_stage"
                @change="handleRadioSearch"
              >
                <el-radio-button :label="-1"
                  >全部({{ stageNum }})</el-radio-button
                >
                <el-radio-button
                  v-for="item in currentStageList"
                  :key="item.key"
                  :label="item.key"
                >
                  {{ `${item.value}(${item.total})` }}
                </el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="学员姓名:" prop="student_name">
              <el-input
                v-model="searchInfo.student_name"
                placeholder="请输入"
                @change="handleSearch"
                clearable
                @clear="handleSearch"
                prefix-icon="el-icon-search"
                maxlength="120"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="学员状态:" prop="student_status">
              <el-select
                v-model="searchInfo.student_status"
                multiple
                clearable
                placeholder="请选择"
                @change="handleSearch"
              >
                <el-option label="意向" :value="1"></el-option>
                <el-option label="在读" :value="2"></el-option>
                <el-option label="历史" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出现方式:" prop="appear_id">
              <el-select
                v-model.number="searchInfo.appear_id"
                filterable
                clearable
                placeholder="请选择"
                @focus="getStudentAppearList('')"
                @change="
                  () => {
                    searchInfo.source_id = '';
                    studentSourceList = [];
                    handleSearchSource();
                    handleSearch();
                  }
                "
              >
                <el-option
                  v-for="item in studentAppearList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="来源渠道:" prop="source_id">
              <el-select
                v-model.number="searchInfo.source_id"
                filterable
                clearable
                placeholder="请选择"
                @change="handleSearch"
                @focus="
                  () => {
                    if (!searchInfo.appear_id) {
                      $message({
                        type: 'warning',
                        message: '请先选择出现方式',
                      });
                    }
                  }
                "
              >
                <el-option
                  v-for="item in studentSourceList"
                  :key="item.source_id"
                  :label="item.name"
                  :value="item.source_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="用户意向:" prop="intent_id">
              <el-select
                v-model="searchInfo.intent_id"
                filterable
                default-first-option
                placeholder="请选择"
                clearable
                @change="handleSearch"
              >
                <el-option label="D" key="0" :value="0"> </el-option>
                <el-option label="C" key="1" :value="1"> </el-option>
                <el-option label="B" key="2" :value="2"> </el-option>
                <el-option label="A" key="3" :value="3"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="获取时间:" prop="acquisition_time">
              <common-date-range-selector
                v-model="searchInfo.acquisition_time"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="handleSearch"
                value-format="yyyy-MM-dd"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="课程顾问:" prop="follow_staff_id">
              <el-select
                v-model="searchInfo.follow_staff_id"
                placeholder="请选择"
                clearable
                filterable
                @focus="handleGetCourseAdviserList('')"
                :filter-method="handleGetCourseAdviserList"
                @change="handleSearch"
              >
                <el-option
                  v-for="item in courseAdviserList"
                  :key="item.staff_id"
                  :label="item.name"
                  :value="item.staff_id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="性别:" prop="sex">
              <el-select
                v-model="searchInfo.sex"
                multiple
                clearable
                placeholder="请选择"
                @change="handleSearch"
              >
                <el-option label="无" :value="0"></el-option>
                <el-option label="男" :value="1"></el-option>
                <el-option label="女" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="年龄分布:" prop="age_stage">
              <el-select
                v-model="searchInfo.age_stage"
                placeholder="请选择"
                clearable
                @change="handleSearch"
              >
                <el-option label="暂无年龄" :value="8"></el-option>
                <el-option label="X ≤ 3" :value="1"></el-option>
                <el-option label="3 < X ≤ 6" :value="2"></el-option>
                <el-option label="6 < X ≤ 9" :value="3"></el-option>
                <el-option label="9 < X ≤ 12" :value="4"></el-option>
                <el-option label="12 < X ≤ 15" :value="5"></el-option>
                <el-option label="15 < X ≤ 18" :value="6"></el-option>
                <el-option label="18 < X" :value="7"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="年龄筛选:" class="filter-age">
              <div class="inputBox">
                <el-input
                  v-model.number="searchInfo.age_start"
                  type="number"
                  placeholder="开始年龄"
                  @change="handleSearch"
                ></el-input>
                <span>至</span>
                <el-input
                  v-model.number="searchInfo.age_end"
                  type="number"
                  placeholder="结束年龄"
                  @change="handleSearch"
                >
                </el-input>
                <span
                  class="el-icon-error clear-icon"
                  v-if="searchInfo.age_start && searchInfo.age_end"
                  @click="
                    () => {
                      searchInfo.age_start = '';
                      searchInfo.age_end = '';
                      handleSearch();
                    }
                  "
                ></span>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="教务老师:" prop="edu_teacher_id">
              <el-select
                v-model="searchInfo.edu_teacher_id"
                placeholder="请选择"
                clearable
                filterable
                @focus="handleGetEduTeacherList('')"
                :filter-method="handleGetEduTeacherList"
                @change="handleSearch"
              >
                <el-option
                  v-for="item in eduTeacherList"
                  :key="item.staff_id"
                  :label="item.name"
                  :value="item.staff_id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="入学时间:" prop="transform_time">
              <common-date-range-selector
                v-model="searchInfo.transform_time"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="handleSearch"
                value-format="yyyy-MM-dd"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="结业时间:" prop="completion_time">
              <common-date-range-selector
                v-model="searchInfo.completion_time"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="handleSearch"
                value-format="yyyy-MM-dd"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="回收时间:" prop="recycle_time">
              <common-date-range-selector
                v-model="searchInfo.recycle_time"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="handleSearch"
                value-format="yyyy-MM-dd"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="删除时间:" prop="delete_time">
              <common-date-range-selector
                v-model="searchInfo.delete_time"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="handleSearch"
                value-format="yyyy-MM-dd"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="创建时间:" prop="create_time">
              <common-date-range-selector
                v-model="searchInfo.create_time"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="handleSearch"
                value-format="yyyy-MM-dd"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="首次到访时间:" prop="first_visited_time">
              <common-date-range-selector
                v-model="searchInfo.first_visited_time"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="handleSearch"
                value-format="yyyy-MM-dd"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="首次体验时间:" prop="first_experienced_time">
              <common-date-range-selector
                v-model="searchInfo.first_experienced_time"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="handleSearch"
                value-format="yyyy-MM-dd"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </common-search-form-wrapper>
    <el-table
      class="mwow-table"
      size="mini"
      v-horizontal-scroll
      :data="tableData"
      stripe
      style="width: 100%"
      tooltip-effect="dark"
      :default-sort="{ prop: 'create_time', order: 'descending' }"
      @sort-change="clickStort"
    >
      <el-table-column label="学员姓名" prop="student.name" width="120">
        <template slot-scope="scope">
          <div
            style="cursor: pointer"
            v-if="scope.row.student && scope.row.student.is_del === 2"
            class="mwow-green"
            @click="goStudentDetail(scope.row.student.student_id.toString())"
          >
            {{ scope.row.student.name || "-" }}
            <span
              v-if="
                scope.row.student.status === 1 && scope.row.is_recycle === 2
              "
              class="mwow-tag primary-filled large"
            >
              意向</span
            >
            <span
              v-if="
                scope.row.student.status === 2 && scope.row.is_recycle === 2
              "
              class="mwow-tag success-filled large"
            >
              在读</span
            >
            <span
              v-if="
                scope.row.student.status === 3 && scope.row.is_recycle === 2
              "
              class="mwow-tag danger-filled large"
            >
              历史</span
            >
          </div>
          <div v-else>
            <div v-if="scope.row.student">
              {{ scope.row.student.name || "-" }}
            </div>
            <div v-else>-</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="性别" prop="student.name" width="60">
        <template slot-scope="scope">
          <div v-if="scope.row.student.sex === 0">无</div>
          <div v-if="scope.row.student.sex === 1">男</div>
          <div v-if="scope.row.student.sex === 2">女</div>
        </template>
      </el-table-column>
      <el-table-column label="年龄" prop="age" width="60">
        <template slot-scope="scope">{{ scope.row.age }}</template>
      </el-table-column>
      <el-table-column label="学员阶段" prop="studentStage"></el-table-column>
      <el-table-column label="教务老师" prop="edu_teacher">
        <template slot-scope="scope">
          <div>
            {{ scope.row.edu_teacher ? scope.row.edu_teacher.name : "-" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="课程顾问" prop="course_adviser">
        <template slot-scope="scope">
          <div>
            {{ scope.row.course_adviser ? scope.row.course_adviser.name : "-" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="出现方式" prop="appear_name">
        <template slot-scope="scope">
          <div>
            {{ scope.row.appear_name || "-" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="来源渠道" prop="student_source.name">
        <template slot-scope="scope">
          <div>
            {{ scope.row.student_source ? scope.row.student_source.name : "-" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="用户意向" prop="intent">
        <template slot-scope="scope">
          {{ followLatentObj[scope.row.intent_id] || "-" }}
        </template>
      </el-table-column>
      <el-table-column label="跟进次数" prop="followed_times">
      </el-table-column>
      <el-table-column
        label="获取时间"
        prop="acquisition_time"
        sortable="custom"
        min-width="120"
        :sort-orders="['ascending', 'descending']"
      >
        <template slot="header">
          <span>
            <span>获取时间</span>
            <el-popover
              placement="top"
              popper-class="followuppopover"
              trigger="hover"
              width="200"
            >
              <p>学员最近一次从其他状态变为意向时的时间</p>
              <i
                class="el-icon-question"
                slot="reference"
                style="
                  margin-left: 8px;
                  color: #bebfc0;
                  font-size: 16px;
                  vertical-align: text-bottom;
                "
              ></i>
            </el-popover>
          </span>
        </template>
        <template slot-scope="scope">
          <div>{{ scope.row.acquisition_time }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="首次到访时间"
        min-width="120"
        prop="first_visited_time"
      ></el-table-column>
      <el-table-column
        label="首次体验时间"
        min-width="120"
        prop="first_experienced_time"
      ></el-table-column>
      <el-table-column
        label="入学时间"
        prop="transform_time"
        sortable="custom"
        min-width="120"
        :sort-orders="['ascending', 'descending']"
      >
        <template slot="header">
          <span>
            <span>入学时间</span>
            <el-popover
              placement="top"
              popper-class="followuppopover"
              trigger="hover"
              width="200"
            >
              <p>首次缴费变为在读学员的时间</p>
              <i
                class="el-icon-question"
                slot="reference"
                style="
                  margin-left: 8px;
                  color: #bebfc0;
                  font-size: 16px;
                  vertical-align: text-bottom;
                "
              ></i>
            </el-popover>
          </span>
        </template>
        <template slot-scope="scope">
          <div>{{ scope.row.transform_time }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="结业时间"
        prop="completion_time"
        sortable="custom"
        min-width="120"
        :sort-orders="['ascending', 'descending']"
      >
      </el-table-column>
      <el-table-column
        label="回收时间"
        prop="recycle_time"
        sortable="custom"
        min-width="120"
        :sort-orders="['ascending', 'descending']"
      >
      </el-table-column>
      <el-table-column
        label="删除时间"
        prop="delete_time"
        sortable="custom"
        min-width="120"
        :sort-orders="['ascending', 'descending']"
      >
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="create_time"
        sortable="custom"
        min-width="120"
        :sort-orders="['ascending', 'descending']"
      >
        <template slot="header">
          <span>
            <span>创建时间</span>
            <el-popover
              placement="top"
              popper-class="followuppopover"
              trigger="hover"
              width="200"
            >
              <p>首次录入系统的时间，不受回收再次转化等影响</p>
              <i
                class="el-icon-question"
                slot="reference"
                style="
                  margin-left: 8px;
                  color: #bebfc0;
                  font-size: 16px;
                  vertical-align: text-bottom;
                "
              ></i>
            </el-popover>
          </span>
        </template>
        <template slot-scope="scope">
          <div>{{ scope.row.create_time }}</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
  </div>
</template>
<script>
import {
  studentStageApi,
  studentStageStatisticsApi,
  statisticsStudentStageListApi,
  statisticsStudentStageListExportApi,
} from "@/api/statistics";
import { staffList } from "@/api/globalSearch";
import {
  getStudentAppearListApi,
  sourceTypeSelectListApi,
} from "@/api/storeManagement";
import { getFollowLatentApi } from "@/api/studentFollow";
import { dateFormat } from "@/utils/timeFormat";
import { exportLoop } from "@/utils/export";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";
import CommonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";

export default {
  components: {
    commonDateRangeSelector,
    CommonSearchFormWrapper,
  },
  data() {
    return {
      searchInfo: {
        current_stage: -1,
        acquisition_time: [],
        transform_time: [],
        completion_time: [],
        recycle_time: [],
        delete_time: [],
        create_time: [],
        first_visited_time: [],
        first_experienced_time: [],
        sort_type: "desc",
        sort_field: "create_time",
      },
      currentStageList: [],
      eduTeacherList: [],
      courseAdviserList: [],
      studentAppearList: [],
      studentSourceList: [],
      followLatentObj: {},
      tableData: [],
      stageNum: 0, // 学员阶段统计数量;
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      searchFormData: {},
      stageObject: {},
    };
  },
  created() {
    // this.mixinGetPageInfo("resourceManagement");
    getFollowLatentApi().then((res) => {
      const obj = {};
      res.data.list.map((item) => {
        obj[item.key] = item.value;
      });
      this.followLatentObj = obj;
    });
    if (this.$route.query.start_time && this.$route.query.end_time) {
      this.searchInfo.create_time.push(
        dateFormat("YYYY-mm-dd", Number(this.$route.query.start_time)),
        dateFormat("YYYY-mm-dd", Number(this.$route.query.end_time))
      );
    }
    if (this.$route.query.follow_staff_id) {
      this.searchInfo.follow_staff_id = Number(
        this.$route.query.follow_staff_id
      );
    }
    if (this.$route.query.appear_id) {
      this.searchInfo.appear_id = Number(this.$route.query.appear_id);
    }
    if (this.$route.query.source_id) {
      this.searchInfo.source_id = Number(this.$route.query.source_id);
      sourceTypeSelectListApi().then((result) => {
        let target = result.data.list.find((s) => {
          return s.source_id === Number(this.$route.query.source_id);
        });
        if (target) {
          this.studentSourceList = [target];
        }
      });
    }
    this.getStageList({}, () => {
      this.getList({
        page: this.page,
        pageSize: this.pageSize,
      });
    });
  },
  methods: {
    getStudentAppearList() {
      if (this.studentAppearList.length > 0) {
        return false;
      }
      getStudentAppearListApi({
        page: 1,
        page_size: 500,
      }).then((res) => {
        if (res.error_code === 0) {
          this.studentAppearList = res.data.list;
        }
      });
    },
    handleSearchSource() {
      if (!this.searchInfo.appear_id) {
        return false;
      }
      sourceTypeSelectListApi({
        appear_id: this.searchInfo.appear_id,
      }).then((res) => {
        if (res.error_code === 0) {
          this.studentSourceList = res.data.list;
        }
      });
    },
    getStageList(val, cb) {
      if (val.current_stage) {
        delete val.current_stage;
      }
      this.stageNum = 0;
      // 等到两个接口请求回来再执行下面请求,以免学员阶段数据拿不到;
      studentStageApi().then((res) => {
        if (res.error_code === 0) {
          studentStageStatisticsApi(val).then((v) => {
            if (v.error_code === 0) {
              this.currentStageList = res.data.list;
              v.data.list.map((item) => {
                this.stageNum += item.total;
              });
              res.data.list.map((it) => {
                v.data.list.map((item) => {
                  this.stageObjectSetHandle(it.key, it.value);
                  if (it.key === item.stage_id) {
                    it.total = item.total;
                  }
                });
              });
              if (cb) {
                cb();
              }
            }
          });
        }
      });
    },
    getList(val) {
      const data = {
        page: val.page,
        page_size: val.pageSize,
      };
      const v = this.searchInfo;
      if (v.current_stage > -1) {
        data.current_stage = v.current_stage;
      }
      if (v.student_name) {
        data.key_word = v.student_name;
      }
      if (v.student_status) {
        data.student_status = v.student_status;
      }
      if (v.sex) {
        data.sex = v.sex;
      }
      if (v.age_stage) {
        data.age_stage = v.age_stage;
      }
      if (v.age_start) {
        data.age_start = v.age_start;
      }
      if (v.age_end) {
        data.age_end = v.age_end;
      }
      if (v.edu_teacher_id) {
        data.edu_teacher_id = v.edu_teacher_id;
      }
      if (v.follow_staff_id) {
        data.follow_staff_id = v.follow_staff_id;
      }
      if (v.appear_id) {
        data.appear_id = v.appear_id;
      }
      if (v.source_id) {
        data.source_id = v.source_id;
      }
      if ((v.intent_id || v.intent_id == 0) && v.intent_id !== "") {
        data.intent_id = Number(v.intent_id);
      }
      if (v.acquisition_time && v.acquisition_time.length > 0) {
        data.acquisition_start_time = v.acquisition_time[0];
        data.acquisition_end_time = v.acquisition_time[1];
      }
      if (v.transform_time && v.transform_time.length > 0) {
        data.transform_start_time = v.transform_time[0];
        data.transform_end_time = v.transform_time[1];
      }
      if (v.completion_time && v.completion_time.length > 0) {
        data.completion_start_time = v.completion_time[0];
        data.completion_end_time = v.completion_time[1];
      }
      if (v.recycle_time && v.recycle_time.length > 0) {
        data.recycle_start_time = v.recycle_time[0];
        data.recycle_end_time = v.recycle_time[1];
      }
      if (v.delete_time && v.delete_time.length > 0) {
        data.delete_start_time = v.delete_time[0];
        data.delete_end_time = v.delete_time[1];
      }
      if (v.create_time && v.create_time.length > 0) {
        data.create_start_time = v.create_time[0];
        data.create_end_time = v.create_time[1];
      }
      if (v.first_visited_time && v.first_visited_time.length > 0) {
        data.first_visited_start_time =
          new Date(v.first_visited_time[0] + " 00:00:01").getTime() / 1000;
        data.first_visited_end_time =
          new Date(v.first_visited_time[1] + " 23:59:59").getTime() / 1000;
      }
      if (v.first_experienced_time && v.first_experienced_time.length > 0) {
        data.first_experienced_start_time =
          new Date(v.first_experienced_time[0] + " 00:00:01").getTime() / 1000;
        data.first_experienced_end_time =
          new Date(v.first_experienced_time[1] + " 23:59:59").getTime() / 1000;
      }
      if (this.searchInfo.sort_type !== "") {
        data.sort_type = this.searchInfo.sort_type;
      }
      if (this.searchInfo.sort_field !== "") {
        data.sort_field = this.searchInfo.sort_field;
      }
      this.searchFormData = JSON.parse(JSON.stringify(data));
      statisticsStudentStageListApi(data).then((res) => {
        if (res.error_code === 0) {
          const today = new Date().getTime();
          res.data.list.map((item) => {
            if (
              item.student.is_del === 1 ||
              (item.student.is_del === 2 && item.is_recycle === 1)
            ) {
              item.studentStage = "-";
            } else {
              let stage = this.stageObjectGetHandle(item.current_stage);
              if (stage === "") {
                stage = "-";
              }
              item.studentStage = stage;
            }
            if (item.create_time) {
              item.create_time = dateFormat(
                "YYYY-mm-dd",
                item.create_time * 1000
              );
            } else {
              item.create_time = "-";
            }
            if (item.acquisition_time) {
              item.acquisition_time = dateFormat(
                "YYYY-mm-dd",
                item.acquisition_time * 1000
              );
            } else {
              item.acquisition_time = "-";
            }
            if (item.completion_time) {
              item.completion_time = dateFormat(
                "YYYY-mm-dd",
                item.completion_time * 1000
              );
            } else {
              item.completion_time = "-";
            }
            if (item.recycle_time) {
              item.recycle_time = dateFormat(
                "YYYY-mm-dd",
                item.recycle_time * 1000
              );
            } else {
              item.recycle_time = "-";
            }
            if (item.delete_time) {
              item.delete_time = dateFormat(
                "YYYY-mm-dd",
                item.delete_time * 1000
              );
            } else {
              item.delete_time = "-";
            }
            if (item.transform_time) {
              item.transform_time = dateFormat(
                "YYYY-mm-dd",
                item.transform_time * 1000
              );
            } else {
              item.transform_time = "-";
            }
            if (item.first_visited_time) {
              item.first_visited_time = dateFormat(
                "YYYY-mm-dd",
                item.first_visited_time * 1000
              );
            } else {
              item.first_visited_time = "-";
            }
            if (item.first_experienced_time) {
              item.first_experienced_time = dateFormat(
                "YYYY-mm-dd",
                item.first_experienced_time * 1000
              );
            } else {
              item.first_experienced_time = "-";
            }
            if (item.age === 0) {
              if (item.birthday !== 0) {
                const severalMonths = today - item.birthday * 1000;
                item.age = new Date(severalMonths).getMonth() + "个月";
              } else {
                item.age = "-";
              }
            } else {
              item.age = item.age + "岁";
            }
          });
          this.tableData = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    // 导出
    handleExport() {
      const data = {};
      const v = this.searchInfo;
      if (v.current_stage > -1) {
        data.current_stage = v.current_stage;
      }
      if (v.student_name) {
        data.key_word = v.student_name;
      }
      if (v.student_status) {
        data.student_status = v.student_status;
      }
      if (v.sex) {
        data.sex = v.sex;
      }
      if (v.age_stage) {
        data.age_stage = v.age_stage;
      }
      if (v.age_start) {
        data.age_start = v.age_start;
      }
      if (v.age_end) {
        data.age_end = v.age_end;
      }
      if (v.edu_teacher_id) {
        data.edu_teacher_id = v.edu_teacher_id;
      }
      if (v.follow_staff_id) {
        data.follow_staff_id = v.follow_staff_id;
      }
      if (v.appear_id) {
        data.appear_id = v.appear_id;
      }
      if (v.source_id) {
        data.source_id = v.source_id;
      }
      if (v.intent_id || v.intent_id == 0) {
        data.intent_id = Number(v.intent_id);
      }
      if (v.acquisition_time && v.acquisition_time.length > 0) {
        data.acquisition_start_time = v.acquisition_time[0];
        data.acquisition_end_time = v.acquisition_time[1];
      }
      if (v.transform_time && v.transform_time.length > 0) {
        data.transform_start_time = v.transform_time[0];
        data.transform_end_time = v.transform_time[1];
      }
      if (v.completion_time && v.completion_time.length > 0) {
        data.completion_start_time = v.completion_time[0];
        data.completion_end_time = v.completion_time[1];
      }
      if (v.create_time && v.create_time.length > 0) {
        data.create_start_time = v.create_time[0];
        data.create_end_time = v.create_time[1];
      }
      // 时间戳
      if (v.first_visited_time && v.first_visited_time.length > 0) {
        data.first_visited_start_time =
          new Date(v.first_visited_time[0] + " 00:00:01").getTime() / 1000;
        data.first_visited_end_time =
          new Date(v.first_visited_time[1] + " 23:59:59").getTime() / 1000;
      }
      // 时间戳
      if (v.first_experienced_time && v.first_experienced_time.length > 0) {
        data.first_experienced_start_time =
          new Date(v.first_experienced_time[0] + " 00:00:01").getTime() / 1000;
        data.first_experienced_end_time =
          new Date(v.first_experienced_time[1] + " 23:59:59").getTime() / 1000;
      }
      if (this.searchInfo.sort_type !== "") {
        data.sort_type = this.searchInfo.sort_type;
      }
      if (this.searchInfo.sort_field !== "") {
        data.sort_field = this.searchInfo.sort_field;
      }
      statisticsStudentStageListExportApi(data).then((res) => {
        if (res.error_code === 0) {
          exportLoop(res.data.task_id);
        }
      });
    },
    handleGetEduTeacherList(v) {
      staffList({
        page: 1,
        page_size: 500,
        key_word: v,
        job_ids: [2],
      }).then((res) => {
        if (res.error_code === 0) {
          this.eduTeacherList = res.data.list;
        }
      });
    },
    handleGetCourseAdviserList(v) {
      staffList({
        page: 1,
        page_size: 500,
        key_word: v,
        job_ids: [3],
      }).then((res) => {
        if (res.error_code === 0) {
          this.courseAdviserList = res.data.list;
        }
      });
    },
    handleSearch() {
      this.getList({
        page: 1,
        pageSize: this.pageSize,
      });
      this.getStageList(this.searchFormData);
    },
    handleRadioSearch() {
      this.getList({
        page: 1,
        pageSize: this.pageSize,
      });
    },
    resetSearch() {
      this.searchInfo = {
        current_stage: -1,
        acquisition_time: [],
        transform_time: [],
        completion_time: [],
        create_time: [],
        first_visited_time: [],
        first_experienced_time: [],
        sort_type: "desc",
        sort_field: "",
      };
      this.getList({
        page: 1,
        pageSize: this.pageSize,
      });
      this.getStageList(this.searchFormData);
      // this.mixinSavePageInfo("resourceManagement");
    },
    goStudentDetail(val) {
      this.$router.push({
        name: "studyDetails",
        query: {
          id: val,
        },
      });
      // this.mixinSavePageInfo("resourceManagement");
    },
    // 排序
    clickStort(e) {
      this.searchInfo.sort_field = e.prop;
      if (e.order == "descending") {
        this.searchInfo.sort_type = "desc";
      } else if (e.order == "ascending") {
        this.searchInfo.sort_type = "asc";
      } else {
        this.searchInfo.sort_type = "";
      }
      this.getList({
        page: 1,
        pageSize: this.pageSize,
      });
    },
    handlePagerChange(e) {
      this.page = e;
      this.getList({
        page: e,
        pageSize: this.pageSize,
      });
      // this.mixinSavePageInfo("resourceManagement");
    },
    handlePagerSizeChange(e) {
      this.page = 1;
      this.pageSize = e;
      this.getList({
        page: 1,
        pageSize: e,
      });
      // this.mixinSavePageInfo("resourceManagement");
    },
    stageObjectSetHandle(key, value) {
      this.$set(this.stageObject, key, value);
    },
    stageObjectGetHandle(key) {
      return this.stageObject[key];
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 !important;
  border-radius: 4px;
  .inputBox {
    display: flex;
    position: relative;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    line-height: 30px;
    height: 30px !important;
    position: relative;
    padding-left: 10px;
    .el-input {
      width: 165px;
    }
    /deep/.el-input__inner {
      border: none !important;
      text-align: center;
    }
    span {
      margin: 0 10px 0 0;
    }
    &:hover {
      .clear-icon {
        display: block;
      }
    }
    .clear-icon {
      position: absolute;
      top: 8px;
      right: 0;
      font-size: 14px;
      color: #d8d8d8;
      cursor: pointer;
      display: none;
    }
    .el-input {
      width: auto;
      text-align: center;
    }
  }
}
.question {
  width: 15px;
  height: 15px;
  background: #bebfc0;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  line-height: 15px;
  font-size: 10px;
  margin-left: 5px;
}
</style>
